var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"sidebar-left__item"},[_c('router-link',{staticClass:"sidebar-left__item",attrs:{"to":{
      name: _vm.routeName
    }}},[(_vm.image)?_c('img',{attrs:{"src":_vm.image}}):(_vm.icon)?_c('i',{staticClass:"icon",class:_vm.icon}):_vm._e(),_c('div',[_c('span',[_vm._v(_vm._s(_vm.text))])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }